<div class="row justify-content-center">
    <div class="col-md-6 col-sm-12">
        <nb-card
            *ngIf="
                currentUserAddress !=
                '0x33c387551e5ca235b06c59093209ac32afa9ef07'
            "
        >
            <nb-card-header>
                <h2 class="h2mobile">Fill the form below</h2>
            </nb-card-header>
            <nb-card-body>
                <form
                    [formGroup]="collectionsForm"
                    action=""
                    class="collectionsForm"
                >
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm">
                                <p>Name</p>
                                <!-- <input required formControlName='name' 
                                    type='text' nbInput fullWidth=""> -->
                                <input
                                    required
                                    formControlName="name"
                                    type="text"
                                    id="name"
                                    name="name"
                                    nbInput
                                    fullWidth=""
                                />

                                <div
                                    *ngIf="
                                        this.collectionsForm.controls['name']
                                            ?.invalid &&
                                        (this.collectionsForm.controls['name']
                                            ?.dirty ||
                                            this.collectionsForm.controls[
                                                'name'
                                            ]?.touched)
                                    "
                                    class=""
                                >
                                    <div
                                        *ngIf="this.collectionsForm.controls['name'].errors?.['required']"
                                        class="dangerDiv"
                                    >
                                        <p class="dangerP">Name is required!</p>
                                    </div>
                                </div>

                                <p>Last name</p>
                                <input
                                    required
                                    formControlName="lname"
                                    type="text"
                                    nbInput
                                    fullWidth=""
                                />

                                <div
                                    *ngIf="
                                        this.collectionsForm.controls['lname']
                                            ?.invalid &&
                                        (this.collectionsForm.controls['lname']
                                            ?.dirty ||
                                            this.collectionsForm.controls[
                                                'lname'
                                            ]?.touched)
                                    "
                                    class=""
                                >
                                    <div
                                        *ngIf="this.collectionsForm.controls['lname'].errors?.['required']"
                                        class="dangerDiv"
                                    >
                                        <p class="dangerP">
                                            Last name is required!
                                        </p>
                                    </div>
                                </div>
                                <p>Email</p>
                                <input
                                    required
                                    formControlName="email"
                                    type="text"
                                    nbInput
                                    fullWidth=""
                                />
                                <div
                                    *ngIf="
                                        this.collectionsForm.controls['email']
                                            ?.invalid &&
                                        (this.collectionsForm.controls['email']
                                            ?.dirty ||
                                            this.collectionsForm.controls[
                                                'email'
                                            ]?.touched)
                                    "
                                >
                                    <div
                                        *ngIf="this.collectionsForm.controls['email'].errors?.['required']"
                                        class="dangerDiv"
                                    >
                                        <p class="dangerP">
                                            E-mail is required!
                                        </p>
                                    </div>
                                </div>
                                <div
                                    *ngIf="
                                        this.collectionsForm.controls['email']
                                            ?.errors?.email
                                    "
                                >
                                    <p class="dangerP">
                                        E-mail format not correct!
                                    </p>
                                </div>
                                <p>Contribution amount (USDC Only)</p>
                                <input
                                    required
                                    formControlName="contributionAmount"
                                    type="number"
                                    nbInput
                                    fullWidth=""
                                />
                                <div
                                    *ngIf="
                                        this.collectionsForm.controls[
                                            'contributionAmount'
                                        ]?.invalid &&
                                        (this.collectionsForm.controls[
                                            'contributionAmount'
                                        ]?.dirty ||
                                            this.collectionsForm.controls[
                                                'contributionAmount'
                                            ]?.touched)
                                    "
                                >
                                    <div
                                        *ngIf="this.collectionsForm.controls['contributionAmount'].errors?.['required']"
                                        class="dangerDiv"
                                    >
                                        <p class="dangerP">
                                            Amount is required!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                                <div class="col-sm">
                                    <ngx-recaptcha2
                                        #captchaElem
                                        [siteKey]="siteKey"
                                        formControlName="recaptcha"
                                    >
                                    </ngx-recaptcha2>
                                </div>
                            </div> -->
                </form>
                <div class="row" *ngIf="minMaxContribError">
                    <div class="col-sm">
                        <div class="dangerDiv">
                            <p class="dangerP">
                                Minimum contribution amount is {{minContrib}} and maximum
                                contribution amount is {{maxContrib}}!
                            </p>
                        </div>
                    </div>
                </div>

                <!-- <div class="row" *ngIf='isInCollection'>
                            <div class="col-sm">
                                <div class="dangerDiv">
                                    <p class="dangerP">
                                        You have alredy contributed!
                                    </p>
                                </div>
                            </div>
                        </div> -->

                <div class="row" *ngIf="!walletHasEnoughFunds">
                    <div class="col-sm">
                        <div class="dangerDiv">
                            <p class="dangerP">
                                You do not have enough funds on your wallet.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button
                        nbButton
                        class="btn btnMiddle btnContrib"
                        status="primary"
                        status="primary"
                        (click)="insertCollectionForm()"
                        [disabled]="!this.collectionsForm.valid"
                    >
                        Contribute
                    </button>
                </div>
            </nb-card-body>
        </nb-card>
    </div>
</div>
